import { SxProps, Theme } from '@mui/material';

/**
 * Shared table styles used across all data tables.
 * Pass `compact: true` for tables with expand/checkbox columns (8px left padding).
 */
export const getTableStyles = (options?: { compact?: boolean }) => {
  const pl = options?.compact ? '8px' : '24px';

  const containerSx: SxProps<Theme> = {
    bgcolor: '#fff',
    borderRadius: '12px',
    overflow: 'hidden',
    border: '1px solid rgba(0,0,0,0.04)',
    '& .MuiTablePagination-root': {
      borderTop: '1px solid rgba(0,0,0,0.08)',
    },
  };

  const tableSx: SxProps<Theme> = {
    minWidth: 700,
    borderCollapse: 'collapse',
    '& .MuiTableCell-root': {
      borderBottom: 'none',
    },
  };

  const tableHeadSx: SxProps<Theme> = {
    backgroundColor: '#112233',
    '& .MuiTableCell-head': {
      color: 'rgba(255,255,255,0.85)',
      fontWeight: 600,
      fontSize: '11.5px',
      textTransform: 'uppercase',
      letterSpacing: '0.6px',
      whiteSpace: 'nowrap',
      py: '13px',
      px: '16px',
      '&:first-of-type': { pl },
      '&:last-of-type': { pr: '24px' },
    },
  };

  const tableBodySx: SxProps<Theme> = {
    '& .MuiTableRow-root': {
      borderBottom: '1px solid rgba(0,0,0,0.04)',
      transition: 'background 0.1s',
      '&:hover': { bgcolor: '#F1F6F8' },
      '&:last-child': { borderBottom: '1px solid rgba(0,0,0,0.04)' },
    },
    '& .MuiTableCell-body': {
      py: options?.compact ? '10px' : '14px',
      px: '16px',
      fontSize: '13.5px',
      color: '#1a2332',
      verticalAlign: 'middle',
      '&:first-of-type': { pl },
      '&:last-of-type': { pr: '24px' },
    },
  };

  return { containerSx, tableSx, tableHeadSx, tableBodySx };
};

// Pre-built variants for convenience
export const standardTableStyles = getTableStyles();
export const compactTableStyles = getTableStyles({ compact: true });
